import { Box, CircularProgress, Typography } from "@material-ui/core";

export default function MessageLoading({ message = "" }) {
  return (
    <Box style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "start",
      marginTop: "8px"
    }}>
      <CircularProgress />
      <Typography style={{ fontWeight: 600, fontSize: "15px", marginLeft: "8px" }}>
        {message}
      </Typography>
    </Box>
  )
}
